@if (showFilter) {
  <app-side-filter
    (filterRemoved)="removeFilter($event)"
    [appliedFilters]="appliedFilters"
    [columnFilters]="columnFilters"
    [isTimeSearchAvailable]="isTimeSearchAvailable"
    [isNotDialLogs]="isNotDialLogs"
    class="header-filter"
  ></app-side-filter>
}
@if (gridRendered && showFilter) {
  <div class="hidden-columns-list" id="ColumnVisibilityHeader">
    @for (col of hiddenColumns; track col) {
      <div
        (click)="setColumnVisibilityColumn(col, true)"
        class="hidden-column-item ag-dnd-ghost ag-unselectable ag-theme-alpine"
        id="ColumnVisibility_{{ col.headerName }}"
        title="Show column"
        >
        <span class="ag-dnd-ghost-icon">
          <span class="ag-icon ag-icon-eye-slash"></span>
        </span>
        <div class="ag-dnd-ghost-label">{{ col.headerName }}</div>
      </div>
    }
  </div>
}
<div waResizeBox="content-box" (waResizeObserver)="resizeGridColumnsDebounced($event)" class="nf-ag-grid" id="ItemTable">
  <ag-grid-angular
    #nfAgGrid
    (gridReady)="onGridReady($event)"
    [columnDefs]="mergedColumnDefinitions"
    [components]="frameworkComponents"
    [getDataPath]="getDataPath"
    [getRowId]="getRowNodeId"
    [gridOptions]="gridOptions"
    [modules]="gridModules"
    [rowData]="rowData"
    class="nf-ag-grid-table ag-theme-alpine"
    id="ItemGrid"
    >
  </ag-grid-angular>
</div>
<div
  [ngClass]="{ open: openMenu }"
  [ngStyle]="{ left: menuLeft + 'px', top: menuTop + 'px' }"
  class="tMenu action-menu"
  id="RowActionMenu"
  >
  @if (selectedItem.actionList.includes('update')) {
    <div
      (click)="actionRequested.emit({ action: 'update', item: selectedItem })"
      class="tActionRow"
      id="EditSelectionButton"
      >
      Edit
    </div>
  }
  @if (selectedItem.actionList.includes('updateRoles')) {
    <div
      (click)="actionRequested.emit({ action: 'edit', item: selectedItem })"
      class="tActionRow"
      id="RowEditRoles_{{ index }}"
      >
      Edit Roles
    </div>
  }
  @if (selectedItem.actionList.includes('rename')) {
    <div
      (click)="actionRequested.emit({ action: 'rename', item: selectedItem })"
      class="tActionRow"
      id="RowEditRoles_{{ index }}"
      >
      Rename
    </div>
  }
  @if (selectedItem.actionList.includes('rotatePassword')) {
    <div
      (click)="actionRequested.emit({ action: 'reset', item: selectedItem })"
      class="tActionRow"
      id="RowReset_{{ index }}"
      >
      New Secret
    </div>
  }
  @if (
    selectedItem.actionList.includes('activateOrDeactivate') || selectedItem.actionList.includes('deactivate')
    ) {
    <div
      (click)="actionRequested.emit({ action: 'deactivate', item: selectedItem })"
      [hidden]="selectedItem.active === 0"
      class="tActionRow"
      id="RowDelete_{{ index }}"
      >
      Deactivate
    </div>
  }
  @if (selectedItem.actionList.includes('activateOrDeactivate') || selectedItem.actionList.includes('activate')) {
    <div
      (click)="actionRequested.emit({ action: 'activate', item: selectedItem })"
      [hidden]="selectedItem.active === 1"
      class="tActionRow"
      id="RowActivate_{{ index }}"
      >
      Activate
    </div>
  }
  @if (selectedItem.actionList.includes('reset') || selectedItem.actionList.includes('resetMfa')) {
    <div
      (click)="actionRequested.emit({ action: 'resetMFA', item: selectedItem })"
      class="tActionRow"
      id="ResetSelectionButton"
      >
      Reset MFA
    </div>
  }
  @if (selectedItem.actionList.includes('reissue')) {
    <div
      (click)="actionRequested.emit({ action: 'reissueToken', item: selectedItem })"
      class="tActionRow"
      id="ResetSelectionButton"
      >
      Reissue Token
    </div>
  }
  @if (selectedItem.actionList.includes('releaseIP')) {
    <div
      (click)="actionRequested.emit({ action: 'releaseIP', item: selectedItem })"
      class="tActionRow"
      id="ResetSelectionButton"
      >
      Release IP
    </div>
  }
  @if (selectedItem.actionList.includes('reEnroll')) {
    <div
      (click)="actionRequested.emit({ action: 'reEnroll', item: selectedItem })"
      class="tActionRow"
      id="ResetSelectionButton"
      >
      Re-Enroll
    </div>
  }
  @if (selectedItem.actionList.includes('share')) {
    <div
      (click)="actionRequested.emit({ action: 'share', item: selectedItem })"
      class="tActionRow"
      id="ShareSelectionButton"
      >
      Share
    </div>
  }
  @if (selectedItem.actionList.includes('topology')) {
    <div
      (click)="actionRequested.emit({ action: 'openTopology', item: selectedItem })"
      class="tActionRow"
      id="TopologySelectionButton"
      >
      Visualize
    </div>
  }
  @if (selectedItem.actionList.includes('invite')) {
    <div
      (click)="actionRequested.emit({ action: 'invite', item: selectedItem })"
      class="tActionRow"
      id="InviteButton"
      >
      Invite
    </div>
  }
  @if (selectedItem.actionList.includes('firewall')) {
    <div
      (click)="actionRequested.emit({ action: 'firewall', item: selectedItem })"
      class="tActionRow"
      id="FirewallButton"
      >
      Firewall Info
    </div>
  }
  @if (selectedItem.actionList.includes('notifications')) {
    <div
      (click)="actionRequested.emit({ action: 'notifications', item: selectedItem })"
      class="tActionRow"
      id="NotifyButton"
      >
      Notifications
    </div>
  }
  @if (selectedItem.actionList.includes('download')) {
    <div
      (click)="actionRequested.emit({ action: 'download', item: selectedItem })"
      class="tActionRow"
      id="DownloadButton"
      >
      Download
    </div>
  }
  @if (selectedItem.actionList.includes('restart')) {
    <div
      (click)="actionRequested.emit({ action: 'restart', item: selectedItem })"
      class="tActionRow"
      id="RestartButton"
      >
      Restart
    </div>
  }
  @if (selectedItem.actionList.includes('resize')) {
    <div
      (click)="actionRequested.emit({ action: 'resize', item: selectedItem })"
      class="tActionRow"
      id="ResizeButton"
      >
      Resize
    </div>
  }
  @if (selectedItem.actionList.includes('suspend') && selectedItem['status'] !== 'SUSPENDED') {
    <div
      (click)="actionRequested.emit({ action: 'suspend', item: selectedItem })"
      class="tActionRow"
      id="SuspendButton"
      >
      Suspend
    </div>
  }
  @if (selectedItem.actionList.includes('resume') && selectedItem['status'] === 'SUSPENDED') {
    <div
      (click)="actionRequested.emit({ action: 'resume', item: selectedItem })"
      class="tActionRow"
      id="ResumeButton"
      >
      Resume
    </div>
  }
  @if (selectedItem.actionList.includes('json')) {
    <div
      (click)="actionRequested.emit({ action: 'json', item: selectedItem })"
      class="tActionRow"
      id="JsonSelectionButton"
      >
      JSON
    </div>
  }
  @if (selectedItem.actionList.includes('publicCert')) {
    <div
      (click)="actionRequested.emit({ action: 'publicCert', item: selectedItem })"
      class="tActionRow"
      id="PublicCertSelectionButton"
      >
      Public Certificate
    </div>
  }
  @if (selectedItem.actionList.includes('move')) {
    <div
      (click)="actionRequested.emit({ action: 'move', item: selectedItem })"
      class="tActionRow"
      id="MoveSelectionButton"
      >
      Move Network
    </div>
  }
  @if (selectedItem.actionList.includes('upgrade')) {
    <div
      (click)="actionRequested.emit({ action: 'upgrade', item: selectedItem })"
      class="tActionRow"
      id="UpgradeSelectionButton"
      >
      Upgrade Network
    </div>
  }
  @if (selectedItem.actionList.includes('migrate')) {
    <div
      (click)="actionRequested.emit({ action: 'migrate', item: selectedItem })"
      class="tActionRow"
      id="MigrateSelectionButton"
      >
      Migrate to V8
    </div>
  }
  @if (selectedItem.actionList.includes('restartAll')) {
    <div
      (click)="actionRequested.emit({ action: 'restartAll', item: selectedItem })"
      class="tActionRow"
      id="RestartAllSelectionButton"
      >
      Restart All
    </div>
  }
  @if (selectedItem.actionList.includes('createBackup')) {
    <div
      (click)="actionRequested.emit({ action: 'createBackup', item: selectedItem })"
      class="tActionRow"
      id="BackupSelectionButton"
      >
      Create Backup
    </div>
  }
  @if (selectedItem.actionList.includes('restoreBackup')) {
    <div
      (click)="actionRequested.emit({ action: 'restoreBackup', item: selectedItem })"
      class="tActionRow"
      id="RestoreSelectionButton"
      >
      Restore Backup
    </div>
  }
  @if (selectedItem.actionList.includes('enableHA')) {
    <div
      (click)="actionRequested.emit({ action: 'enableHA', item: selectedItem })"
      class="tActionRow"
      id="RestoreSelectionButton"
      >
      Enable HA
    </div>
  }
  @if (selectedItem.actionList.includes('enableFips')) {
    <div
      (click)="actionRequested.emit({ action: 'enableFips', item: selectedItem })"
      class="tActionRow"
      id="EnableFipsSelectionButton"
      >
      Enable FIPS
    </div>
  }

  @if (selectedItem.actionList.includes('delete')) {
    <div
      (click)="actionRequested.emit({ action: 'delete', item: selectedItem })"
      class="tActionRow"
      id="DeleteSelectionButton"
      >
      Delete
    </div>
  }

  @if (selectedItem.actionList.includes('supportinfo')) {
    <div
      (click)="actionRequested.emit({ action: 'supportinfo', item: selectedItem })"
      class="tActionRow"
      id="DeleteSelectionButton"
      >
      Support Info
    </div>
  }
  @if (selectedItem.actionList.includes('configPort')) {
    <div
      (click)="actionRequested.emit({ action: 'configPort', item: selectedItem })"
      class="tActionRow"
      id="DeleteSelectionButton"
      >
      Manage Config
    </div>
  }
  @if (selectedItem.actionList.includes('offboard')) {
    <div
      (click)="actionRequested.emit({ action: 'offboard', item: selectedItem  })"
      class="tActionRow"
      id="OffboardCustomerButton"
      >
      Offboard
    </div>
  }
</div>
<div
  [ngClass]="{ open: openHeaderMenu }"
  [ngStyle]="{ left: menuLeft + 'px', top: menuTop + 'px' }"
  class="tMenu action-menu header-menu"
  id="HeaderActionMenu"
  >
  <div (click)="resetTableColumns()" class="tActionRow" id="ResetTableButton">Restore Default Table</div>

  @if (showDownload()) {
    <div
      (click)="actionRequested.emit({ action: 'downloadAll' })"
      class="tActionRow"
      id="DownloadAllToCSV"
      >
      {{ view === 'users' ? 'Download User Roles' : 'Download All' }}
    </div>
  }
  @if (anySelected()) {
    <div
      (click)="actionRequested.emit({ action: 'downloadCsv' })"
      class="tActionRow"
      id="DownloadCSV_Bulk"
      >
      Download Selected
    </div>
  }
  @if (tableId == 'customers') {
    <div
      (click)="actionRequested.emit({ action: 'downloadUsageReport' })"
      class="tActionRow"
      id="DownloadCustomerUsageReport"
      >
      Download Usage Report
    </div>
  }
</div>
<div
  (clickOutside)="closeHeaderFilter($event)"
  [ngClass]="{ open: showFilterOptions }"
  [ngStyle]="{ left: menuLeft + 'px', top: menuTop + 'px' }"
  class="tMenu action-menu header-menu"
  id="HeaderFilterOptions"
  >
  @for (filter of filterOptions; track filter) {
    <div (click)="applyFilter($event, filter)" class="tActionRow">
      @if (filter.bubbleClass) {
        <span [ngClass]="filter.bubbleClass" class="bubble">
          @if (filter.showLoader) {
            <svg class="circular" viewBox="25 25 50 50">
              <circle
                class="path"
                cx="50"
                cy="50"
                fill="none"
                r="20"
                stroke-miterlimit="10"
                stroke-width="3"
              ></circle>
            </svg>
          }
        </span>
      }
      {{ filter.label }}
    </div>
  }
</div>
